import { render, staticRenderFns } from "./A7PessoaEntityChooser.vue?vue&type=template&id=585e6bb2&scoped=true&"
import script from "./A7PessoaEntityChooser.vue?vue&type=script&lang=js&"
export * from "./A7PessoaEntityChooser.vue?vue&type=script&lang=js&"
import style0 from "./A7PessoaEntityChooser.vue?vue&type=style&index=0&id=585e6bb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585e6bb2",
  null
  
)

export default component.exports